import "./SectionCard.css";

export default function SectionCard({

    title,

    icon = "bar-chart",

    children,
    className = "",

}) {

    return (

        <div className={`analytics-section mb-4 analytics-section-card ${className}`.trim()}>

            <div className="analytics-section-header">

                <i
                    className={`bi bi-${icon}`}
                    style={{
                        fontSize: "1.4rem",
                        color: "#2563eb",
                    }}
                />

                <h4 className="analytics-section-title">

                    {title}

                </h4>

            </div>

            <div className="analytics-section-body">

                {children}

            </div>

        </div>

    );

}
